import store from './../store'

export default {
  path: '/business-admins',
  name: 'business-admins',
  // redirect
  component: () => import('@/views/business-admins/index.vue'),
  children: [
    {
      path: '/business-admins/:businessAdminId',
      name: 'business-admins.view-business-admin',
      component: () => import('@/views/business-admins/ViewBusinessAdmin.vue'),
    },
  ],
  beforeEnter: async (to, from, next) => {
    if (store.state.auth.user) {
      if (store.state.auth.user.user_type !== 'business_admin')
        next({ name: 'page-not-found' })

      next()
    } else {
      store
        .dispatch('auth/getAuthenticatedUser')
        .then(() => {
          if (store.state.auth.user.user_type !== 'business_admin')
            next({ name: 'page-not-found' })
        })
        .catch(() => next({ name: 'auth.login-page' }))
        .finally(() => next())
    }
  },
}
